<template>
  <div class="card-wrapper">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :expoMeetingStatus="expoMeetingStatus"
      @reload="reload"
      @openEdit="openEdit"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEdit="openEdit"
      >
        <template slot-scope="{ form }">
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="ml-2 clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              variant="outline-success"
              @click="exportFile(form)"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="ml-3 clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="
              allow('S') && expoMeetingStatus != 'E' && expoMeetingStatus != 'D'
            "
            :disabled="!checkedRowCount"
          >
            <b-button
              size="sm"
              variant="outline-primary"
              @click="arrangeSample({ pageType: 'add' })"
              :disabled="!checkedRowCount"
            >
              {{ $l('btn_arrange') ||'安排寄样' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :title="editOptions.title"
      :selectionCode="editOptions.selectionCode"
      :expoMeetingCode="expoMeetingCode"
      @reload="reload"
    />

    <EditSample
      :visible.sync="editSample.visible"
      :type="editSample.type"
      :meetTitle="false"
      :expoSampleCode="editSample.expoSampleCode"
      @reload="reload"
    />

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'digicenter-meetingsetselection' }"
      :exportOptions="{
        params: { ...chooseTemplateOptions.params },
        checkUrl: '/digitalCenter/expo/meeting/selection/exportCheck',
      }"
      @export-success="clearCheckboxRow"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import EditForm from '../sapmle-edit-form'
import ChooseTemplate from '@/views/digital/components/choose-template'
import EditSample from '@/views/digital/expo/choiceSample/components/edit-form'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditForm, ChooseTemplate, EditSample },
  props: {
    expoMeetingCode: { type: String, default: '' },
    expoMeetingStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
    custName: { type: String, default: '' },
  },
  data() {
    return {
      checkedRows: [],
      usePage: true,
      localTimeZone: '',
      editOptions: { visible: false, selectionCode: '' },
      editSample: { visible: false, selectionCode: '' },
      chooseTemplateOptions: { visible: false, params: {} },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async getData(form) {
      if (!this.expoMeetingCode) return
      this.loading = true
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoMeetingSelectionListApi({
          ...form,
          ...this.page,
          expoMeetingCode: this.expoMeetingCode,
          localTimeZone,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
      // this.clearCheckboxRow()
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    openEdit({ type, data = {} }) {
      const { selectionCode, expoSampleCode } = data
      if (type == 'edit') {
        this.editSample = { visible: true, type, expoSampleCode }
        return
      }
      const types = {
        arrange:
          this.$l('dialog_title_customer_selection_record') || '客人选品记录',
        detail:
          this.$l('dialog_title_customer_selection_details') || '客人选品详情',
      }
      this.editOptions = {
        visible: true,
        type,
        selectionCode,
        title: types[type],
      }
    },
    async exportFile(searchForm = {}) {
      const listSelectionCode = this.checkedRows.map(
        (item) => item.selectionCode
      )
      const localTimeZone = await this.loadLocalTimeZone()
      this.chooseTemplateOptions = {
        visible: true,
        params: {
          listSelectionCode,
          ...searchForm,
          expoMeetingCode: this.expoMeetingCode,
          localTimeZone,
        },
      }
    },
    async arrangeSample({ pageType, params = {}, query = {} }) {
      let msg = `${
        this.$l('tip_currently_selected') || '当前选中了'
      } <span style="color:#409EFF;font-size:20px;font-weight: bold;">${
        this.checkedRowCount
      }</span> ${
        this.$l('tip_create_sample') ||
        '个选品，点击确定将自动跳转到创建寄样单页面'
      }`
      let flag = true
      const sampleData = this.checkedRows
      sampleData.forEach((item) => {
        if (!item.sampleStyleNo) {
          msg =
            this.$l('tip_can_not_create_sample') ||
            '选品中包含未绑定样品的数据，不可安排寄样'
          flag = false
        }
      })

      this.$confirm(msg, this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        if (flag) {
          this.$router.push({
            name: 'customerManage-sendSample-detail',
            params: {
              ...params,
              sampleData,
              custCode: this.custCode,
              custName: this.custName,
              pageType,
            },
            query,
          })
          this.clearCheckboxRow()
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
.card-wrapper {
  background-color: #ffffff;
  border-radius: 6px;
}
</style>
